var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { chapeauStyle } from './styles';
function Chapeau(_a) {
    var { children, inverted = false, size = 'medium' } = _a, restProps = __rest(_a, ["children", "inverted", "size"]);
    return (_jsx(Text, Object.assign({ as: "p", css: chapeauStyle({ inverted, size }) }, restProps, { children: children })));
}
export default Chapeau;
